import React from 'react'
import Configuration from '../../utils/configuration';

export default function Carrousel(props) {
    let part = props.part;
    return (
        <div className="carrousel" style={{backgroundImage: `url(${Configuration.RESOURCES_URL}static/carrousel-bg.png)`}}>
            <div className="content-carrousel">
                <div className="viewport">
                {
                    part['media']['gallery'].map(image => 
                        <div className="item" style={{backgroundImage: `url(${image['path']})`}}>
                            <div className="lens"></div>
                        </div>
                    )
                }
                </div>
            </div>
            <div className="prev-button"><i className="fa fa-caret-left" aria-hidden="true"></i></div>
            <div className="next-button"><i className="fa fa-caret-right" aria-hidden="true"></i></div>
        </div>
    )
}


